export const modifyInputNumberValue = ({ value, min, max, maxLength, }) => {
    if (min && Number(value) < min) {
        return true;
    }
    else if (max && Number(value) > max) {
        return true;
    }
    else if (maxLength && String(value).length > maxLength) {
        return true;
    }
    return false;
};
//# sourceMappingURL=modifyInputNumberValue.js.map